import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { auth } from "../firebase";
import { getUserRole } from "../utils/getUserRole";

export default function RequireAdmin({ children }) {
  const [authorized, setAuthorized] = useState(null);

  useEffect(() => {
    const checkRole = async () => {
      if (!auth.currentUser) {
        setAuthorized(false);
        return;
      }
      const role = await getUserRole();
      setAuthorized(role === "admin");
    };

    checkRole();
  }, []);

  if (authorized === null) return <p>Loading...</p>;

  return authorized ? children : <Navigate to="/login" replace />;
}
